import { createContext, useContext } from 'react'

/**
 * Where dialogs and popovers are drawn. The widget leaves it unset (document.body);
 * the templates render SDK sets it to its shadow root, so a card's drawer or dialog
 * stays inside the card's styles instead of landing unstyled in the host page.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null)

export const usePortalContainer = () => useContext(PortalContainerContext) ?? undefined
